import { render, staticRenderFns } from "./TopBrands.vue?vue&type=template&id=2fe64662&scoped=true"
import script from "./TopBrands.vue?vue&type=script&lang=js"
export * from "./TopBrands.vue?vue&type=script&lang=js"
import style0 from "./TopBrands.vue?vue&type=style&index=0&id=2fe64662&prod&lang=scss&scoped=true"
import style1 from "./TopBrands.vue?vue&type=style&index=1&id=2fe64662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe64662",
  null
  
)

export default component.exports